export default __webpack_public_path__ + "static/media/dentalMenuLogo.b66b5987.png";